export const SupportedLanguages = {
  English: 'en',
  French: 'fr',
} as const

export type SupportedLanguage =
  (typeof SupportedLanguages)[keyof typeof SupportedLanguages]

export const DEFAULT_LANGUAGE: SupportedLanguage = SupportedLanguages.English

export const availableLanguages = [
  { label: 'core.language.english', value: SupportedLanguages.English },
  { label: 'core.language.french', value: SupportedLanguages.French },
] as const

// BCP47 language tags for LLM APIs
export const BCP47LanguageTags = {
  EN_GB: 'en-GB',
  FR_FR: 'fr-FR',
} as const

export type BCP47LanguageTag =
  (typeof BCP47LanguageTags)[keyof typeof BCP47LanguageTags]

export const availableLLMLanguages = [
  { label: 'core.language.english', value: BCP47LanguageTags.EN_GB },
  { label: 'core.language.french', value: BCP47LanguageTags.FR_FR },
] as const
